import React from 'react';
import { useDarkBody } from '../hooks';

function Projects() {
  useDarkBody()
    return (
      <div className="view">
        <div className="content">
          <div className="content--inner">
          <h2>Coming Soon</h2>
          </div>
        </div>
      </div>
    );
}

export default Projects



// WEBPACK FOOTER //
// ./src/views/Projects.js